import { Currency } from '@/network/graphql.g'
import React from 'react'

export const CurrencyContext = React.createContext<Currency>(null)
